import React from "react";
import { XIcon } from "lucide-react";
import { useTheme } from "../../context/ThemeContext";
import { getThemeClasses } from "../utils/themeClass";

const Footer = () => {
  const { theme } = useTheme();
  const themeClass = getThemeClasses(theme);

  return (
    <footer
      className={`z-10 py-10 mt-1 border-t transition-all ${themeClass.bgColor} ${themeClass.borderColor} ${themeClass.baseText}`}
    >
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 text-center md:text-left">
        {/* Quick Links */}
        <div>
          <h3 className={`text-lg font-bold mb-3 ${themeClass.titleColor}`}>
            Quick Links
          </h3>
          <ul className="space-y-2 text-sm">
            {["Home", "About Us", "Contact Us", "Categories", "Search games"].map(
              (item, idx) => {
                const href = ["/", "/about", "/contact", "/categories", "/search"][idx];
                return (
                  <li key={idx}>
                    <a
                      href={href}
                      className={`transition ${themeClass.overlayText} ${themeClass.hoverAccentText}`}
                    >
                      {item}
                    </a>
                  </li>
                );
              }
            )}
          </ul>
        </div>

        {/* Informational Links */}
        <div>
          <h3 className={`text-lg font-bold mb-3 ${themeClass.titleColor}`}>
            Explore Browser Games
          </h3>
          <ul className="space-y-2 text-sm">
            {[
              ["What Are Browser Games?", "/about-browser-games"],
              ["Best Browser Games 2025", "/best-browser-games"],
              ["Free Games – No Downloads", "/free-games"],
              ["Top HTML5 Games", "/html5-games"],
            ].map(([text, href], idx) => (
              <li key={idx}>
                <a
                  href={href}
                  className={`transition ${themeClass.overlayText} ${themeClass.hoverAccentText}`}
                >
                  {text}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Social */}
        <div>
          <h3 className={`text-lg font-bold mb-3 ${themeClass.titleColor}`}>
            Follow Us
          </h3>
          <div className="flex justify-center md:justify-start space-x-4 mt-2">
            <a
              href="https://x.com/browserarena"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow BrowserArena on X"
              className={`transition flex items-center space-x-1 ${themeClass.overlayText} ${themeClass.hoverAccentText}`}
            >
              <XIcon size={20} />
              <span className="text-sm hidden sm:inline">Twitter</span>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Text */}
      <div className={`mt-10 text-center text-sm space-y-1 ${themeClass.overlayText}`}>
        <p>
          &copy; 2024{" "}
          <span className={`${themeClass.titleColor}`}>BrowserArena.com</span> | All
          rights reserved.
        </p>
        <p>
          <a href="/privacy-policy" className={`${themeClass.hoverAccentText}`}>
            Privacy Policy
          </a>{" "}
          &nbsp;|&nbsp;
          <a href="/terms-conditions" className={`${themeClass.hoverAccentText}`}>
            Terms & Conditions
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
